/*----------------------------------------------------

	util.js

----------------------------------------------------*/

// Polyfill forEach for ES5
if(window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// is visible
function isVisible(obj){
  return obj.offsetWidth > 0 || obj.offsetHeight > 0;
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  return (
    rect.top < windowHeight &&
    rect.bottom > 0
  );
}

// insert after
function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

// cookies
function setCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function deleteCookie(name) {
  setCookie(name,"",-1);
}


// Debounce function to limit the frequency of scroll events
function debounce(func, wait, immediate){
  let timeout;
  return function() {
    const context = this, args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}




/* dynamic loading
----------------------------------------------------------------------------------------------------*/

function loadScript(url){
  (function(document, tag) {
      var scriptTag = document.createElement(tag), // create a script tag
          firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
      scriptTag.src = url; // set the source of the script to your script
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
  }(document, 'script'));
}

function loadCSS(url){
  var head = document.getElementsByTagName('head')[0];
  var link  = document.createElement('link');
  link.rel  = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  head.appendChild(link);
}

// lightbox - baguetteBox
/*if(document.querySelectorAll('.gallery').length > 0 || document.querySelectorAll('.lightbox').length > 0 || document.querySelectorAll('.lightbox--video').length > 0){
  loadScript('/inc/js/baguetteBox.js');
  loadCSS('/inc/css/plugins/baguetteBox.css');
}*/


/* external links in new tab
----------------------------------------------------------------------------------------------------*/

var links = document.links;

for(var i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname != window.location.hostname || links[i].getAttribute('href').match('.pdf$')) {
    links[i].target = '_blank';
  }
}




/* JS / bubble links
----------------------------------------------------------------------------------------------------*/

(function(){

  'use strict';

  // Feature Test
  if('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach){

    var bubbleLink = document.querySelectorAll('.js-link');
    [].forEach.call(bubbleLink, function(bubble){

      bubble.addEventListener('click', function(e){

        e.preventDefault();

        var destination_link = bubble.querySelector('a:first-of-type');
        var destination = bubble.querySelector('a:first-of-type').getAttribute('href');
        if(destination){
          if(e.ctrlKey || bubble.getAttribute('target') == '_blank' || bubble.querySelector('a:first-of-type').classList.contains('externalLink')){
            simulateClick(destination_link,true);
    			}else{
            simulateClick(destination_link);
    			}
        }

      }, false);

    });

  }

})();

var simulateClick = function(elem,ctrl=false){
  // Create our event (with options)
  var evt = new MouseEvent('click', {
    bubbles: false,
    cancelable: true,
    view: window,
    ctrlKey: ctrl
  });
  // If cancelled, don't dispatch our event
  var canceled = !elem.dispatchEvent(evt);
};



/* generic showhide
----------------------------------------------------------------------------------------------------*/

var showhide_links = document.querySelectorAll('[data-showhide],[data-showhidemobile]');

// For each
[].forEach.call(showhide_links, function(link){

  link.addEventListener('click', function(ev){

    console.log('showhideclick');

    // Prevent the default link behavior
    ev.preventDefault();
    ev.stopPropagation();

    var target = document.querySelector(link.getAttribute('href'));

    if(target.classList.contains('show')){
      target.classList.remove('show');
    }else{
      closeShowHide(ev);
      target.classList.add('show');

      var child_links = target.querySelectorAll('a:not([href^="#"])');
      [].forEach.call(child_links, function(cl){
        cl.addEventListener('click', function(ev){
          closeShowHide(target);
        });
      });

    }

  });

});


function closeShowHide(ev){
  var docclose = document.querySelectorAll('[data-docclose]');

  [].forEach.call(docclose, function(link){
    if(isVisible(link) && ev.target !== link && !link.contains(ev.target)){
      link.classList.remove('show');
    }
  });
}

document.addEventListener('click', function(ev){
  closeShowHide(ev);
});

